import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=e15497ee&scoped=true"
import script from "@/controllers/productForm.js?vue&type=script&lang=js&external"
export * from "@/controllers/productForm.js?vue&type=script&lang=js&external"
import style0 from "./ProductForm.styles.scss?vue&type=style&index=0&id=e15497ee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15497ee",
  null
  
)

export default component.exports